<template>
  <timeline-step :dusk="`timeline-step-${step.id}`" :step="step" @toggleStep="toggleStep(step.id)">
    <div v-if="joined" v-html="campaignOrderGuidelines" />
    <div
      v-else-if="applied"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-green-600 font-bold text-sm"
    >
      Thank you for applying for this campaign! Our team will review your application &amp; get back to you soon!
    </div>
    <div
      v-else-if="!joined && !applied && !campaignApplyByPassed"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-green-600 font-bold text-sm"
    >
      Apply to the campaign using the "Join campaign" button
    </div>
    <div
      v-else-if="!joined && !applied && campaignApplyByPassed"
      class="block mt-4 py-3 px-4 uppercase text-center text-white mb-4 bg-gray-600 font-bold text-sm"
    >
      Applications are closed
    </div>
  </timeline-step>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  props: ['step'],
  computed: {
    ...mapState('timeline', ['campaignOrderGuidelines']),
    ...mapGetters('timeline', ['applied', 'joined', 'campaignApplyByPassed']),
  },
};
</script>
